import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=3ae9bdec&scoped=true&"
import script from "./Applicant.vue?vue&type=script&lang=js&"
export * from "./Applicant.vue?vue&type=script&lang=js&"
import style0 from "./Applicant.vue?vue&type=style&index=0&id=3ae9bdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae9bdec",
  null
  
)

export default component.exports